var _defs, _circle, _circle2, _circle3, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPart135Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-label": "14 CFR Part 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p135Ring",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A6B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#065B70"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    fill: "url(#p135Ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 68,
    fill: "none",
    stroke: "#35D7E4",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0A6B8C",
    transform: "translate(80 62)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 2,
    rx: 34,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 0 L-36 -10 L-32 2 L-36 12 L-8 4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0 L38 -8 L34 2 L36 10 L10 4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 4 L40 14 L34 14 L24 6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 4 L-32 16 L-26 16 L-14 6 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -10,
    width: 8,
    height: 8,
    rx: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 104,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.5,
    fill: "#0A6B8C"
  }, "PART 135")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    letterSpacing: 1,
    fill: "#065B70"
  }, "CHARTER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPart135Badge);
export default __webpack_public_path__ + "static/media/Part135_Badge.4ec208cb5eb703cdec9a80a8740c831e.svg";
export { ForwardRef as ReactComponent };